<template>
  <v-stepper-items class="visit-content">
    <v-stepper-content
      v-if="displayProfileStep"
      :step="1"
    >
      <ProfileStep
        :change-step="changeStep"
        :active="active"
      />
    </v-stepper-content>
    <v-stepper-content :step="getNumberOfSteps - 1">
      <PetStep
        :change-step="changeStep"
        :active="active"
        :number-of-steps="getNumberOfSteps"
      />
    </v-stepper-content>
    <v-stepper-content :step="getNumberOfSteps">
      <AppointmentStep
        :change-step="changeStep"
        :active="active"
        :number-of-steps="getNumberOfSteps"
      />
    </v-stepper-content>
    <v-stepper-content :step="getNumberOfSteps + 1">
      <SummaryStep
        :change-step="changeStep"
        :active="active"
        :number-of-steps="getNumberOfSteps"
      />
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import ProfileStep from './profileStep/ProfileStep'
import PetStep from './petStep/PetStep'
import AppointmentStep from './appointmentStep/AppointmentStep'
import SummaryStep from './summaryStep/SummaryStep'

export default {
  name: 'StepperContent',
  components: {
    ProfileStep,
    PetStep,
    AppointmentStep,
    SummaryStep,
  },
  props: {
    isProfileComplete: {
      type: Boolean,
      required: true,
    },
    active: {
      type: Number,
      required: true,
    },
    changeStep: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      displayProfileStep: !this.isProfileComplete,
    }
  },
  computed: {
    getNumberOfSteps() {
      return this.displayProfileStep ? 3 : 2
    },
  },
}
</script>

<style lang="stylus" scoped>
  .visit-content {
    height: 100%
  }
  .visit-content >>> .v-stepper__content {
    height: 100%
  }
  .visit-content >>> .v-stepper__wrapper {
    height: 100%
  }
</style>
